import i from "../../designTokens/index.js";
const {
  breakpoints: { mobile: d, tablet: a }
} = i, t = d, r = a;
function f(n, e = t) {
  return n ? `@media only screen and (max-width: ${e}px) {
      ${n}
    }` : "";
}
function p(n, e = t) {
  return n ? `@media only screen and (min-width: ${e}px) {
      ${n}
    }` : "";
}
function h(n, e = t, o = r) {
  return n ? `@media only screen and (min-width: ${e}px) and (max-width: ${o}px) {
      ${n}
    }` : "";
}
function x(n, e = r) {
  return n ? `@media only screen and (min-width: ${e}px) {
      ${n}
    }` : "";
}
const $ = (n) => `
    @media (hover: hover) {
      ${n}
    }
  `;
export {
  x as forDesktopUp,
  f as forPhoneOnly,
  h as forTabletOnly,
  p as forTabletUp,
  $ as hoverSupported,
  t as maxPhoneWidth,
  r as maxTabletWidth
};
